import { useNavigate, useParams } from 'react-router'
import { webhooksApi } from '~/apis/webhooksApi'
import { useUserState } from '~/atoms/UserState'
import { toaster } from '~/components/ui/toaster'

import { WebhookDetailPage } from '@mangovoice/webhooks-ui'

export const WebhooksDetailPage = () => {
  const { integrationId } = useParams<{ integrationId: string }>()
  const { pbxId } = useUserState()
  const navigate = useNavigate()

  const handleToggleError = () => {
    toaster.create({
      type: 'error',
      title: 'Failed to update integration status',
    })
  }

  return (
    <WebhookDetailPage
      api={webhooksApi}
      pbxId={pbxId ?? 0}
      integrationId={Number(integrationId)}
      navigate={navigate}
      imageBaseUrl="/integrations/"
      onToggleError={handleToggleError}
    />
  )
}
